module.exports = __webpack_public_path__ + "img/index-top2.c15eb569.png";